
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouter as ObiRouterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router.js';
 
 
 

 
 export const ObiRouter = createComponent({
   react: React,
   tagName: 'obi-router',
   elementClass: ObiRouterElement,
   events: {
     
   }
  });
 
 